export default "__VITE_ASSET__05856b84__"